module.exports = __webpack_public_path__ + "src/app/_content/MOTFonts/BMWMotorradW01-Italic.ttf?ad2cea972f5fd9c6b9c91317e7de6536";